import {
  applyTheme,
  THEME_PREF_COOKIE_KEY,
  THEME_RESOLVED_COOKIE_KEY,
  LEGACY_THEME_STORAGE_KEY,
  parseThemePreference,
  resolveTheme,
  THEME_STORAGE_KEY
} from '~/utils/theme';

export default defineNuxtPlugin(() => {
  if (!process.client) {
    return;
  }

  const stored = localStorage.getItem(THEME_STORAGE_KEY) ?? localStorage.getItem(LEGACY_THEME_STORAGE_KEY);
  const preference = parseThemePreference(stored);
  const resolved = resolveTheme(
    preference,
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
  const preferenceCookie = useCookie(THEME_PREF_COOKIE_KEY, {
    path: '/',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 365
  });
  const resolvedCookie = useCookie(THEME_RESOLVED_COOKIE_KEY, {
    path: '/',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 365
  });

  preferenceCookie.value = preference;
  resolvedCookie.value = resolved;
  applyTheme(resolved);
});
